import { render, staticRenderFns } from "./FBComments.vue?vue&type=template&id=3c975710&scoped=true"
import script from "./FBComments.vue?vue&type=script&lang=js"
export * from "./FBComments.vue?vue&type=script&lang=js"
import style0 from "./FBComments.vue?vue&type=style&index=0&id=3c975710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c975710",
  null
  
)

export default component.exports